import { MutationTree } from "vuex";
import { IPropertyEditState } from "../property-states.store";
import propertyEnvironmentTypesStore from "./property-environment-types.store";
import { ILookupPropertyEnvironment } from "../../../../models/lookup/property.environment.model";
import {
	IPropertyMultModel,
	IPropertyEnvironmentPicture,
	IPropertyEnvironmentPictureStorage
} from "../../../../models/property";
import { itemStateConstant } from "../../../../common";
import Vue from "vue";
import { IPropertyEnvironmentPointMapList } from "../../../../models/property/property-environment-point.model";
import {IPropertyEnvironmentAddressModel} from "../../../../models/property/property-environment.address.model";

const environmentMutations: MutationTree<IPropertyEditState> = <MutationTree<IPropertyEditState>>{
	[propertyEnvironmentTypesStore.Set.LIST_PROPERTY_ENVIRONMENT]: (
		state: IPropertyEditState,
		payload: ILookupPropertyEnvironment[]
	) => {
		state.listOfSelectPropertyEnvironment = payload || [];
	},
	[propertyEnvironmentTypesStore.Set.SET_PROPERTY_ENVIRONMENT]: (
		state: IPropertyEditState,
		payload: IPropertyMultModel[]
	) => {
		state.property.Environments = payload;
	},
	[propertyEnvironmentTypesStore.Set.LIST_PICTURE_PROPERTY_ENVIRONMENT]: (
		state: IPropertyEditState,
		payload: IPropertyEnvironmentPicture[]
	) => {
		state.property.PicturesOfEnvironment = payload;
	},
	[propertyEnvironmentTypesStore.Set.UPDATE_PICTURE_PROPERTY_ENVIRONMENT]: (
		state: IPropertyEditState,
		payload: IPropertyEnvironmentPicture
	) => {
		let payloadExisted = state.property.PicturesOfEnvironment.find(
			item => item.PictureNumber === payload.PictureNumber
		);
		if (payloadExisted) {
			state.property.PicturesOfEnvironment.map(item => {
				if (
					item.PictureNumber === payload.PictureNumber &&
					item.PropertyId > 0
				) {
					item.ItemState = itemStateConstant.Modified;
					item.OriginalUrl = payload.OriginalUrl;
				}
				if (
					item.PictureNumber === payload.PictureNumber &&
					item.PropertyId <= 0
				) {
					item.OriginalUrl = payload.OriginalUrl;
				}
				return item;
			});
		} else {
			state.property.PicturesOfEnvironment.push(payload);
		}
	},
	[propertyEnvironmentTypesStore.Set.URL_PICTURE_FROM_STORAGE]: (
		state: IPropertyEditState,
		payload: IPropertyEnvironmentPictureStorage
	) => {
		let PicturesOfEnvironmentExist = state.listOfPropertyEnvironmentPictureStorage.find(
			item => payload.PictureNumber === item.PictureNumber
		);
		if (PicturesOfEnvironmentExist) {
			let PicturesOfEnvironment = state.listOfPropertyEnvironmentPictureStorage.map(
				item => {
					if (item.PictureNumber === payload.PictureNumber)
						item.UrlPicture = payload.UrlPicture;
					return item;
				}
			);
			state.listOfPropertyEnvironmentPictureStorage = PicturesOfEnvironment;
		} else {
			state.listOfPropertyEnvironmentPictureStorage.push(payload);
		}
	},
	[propertyEnvironmentTypesStore.Set.LIST_PROPERTY_ENVIRONMENT_POINT]: (
		state: IPropertyEditState,
		payload: IPropertyEnvironmentPointMapList
	) => {
		state.ListOfPropertyEnvironmentPointMapList = payload;
		console.log(state.ListOfPropertyEnvironmentPointMapList);
	},
	[propertyEnvironmentTypesStore.Set.ASSIGVALUE_TO_OPTION_VIEW]: (
		state: IPropertyEditState,
		payload
	) => {
		if (
			state.property &&
			state.property.PoiOfEnvironment &&
			state.property.PoiOfEnvironment.OptionView
		)
			Object.keys(payload).forEach(key =>
				Vue.set(state.property.PoiOfEnvironment.OptionView, key, payload[key])
			);
	},
	[propertyEnvironmentTypesStore.Set.ASSIGVALUE_TO_TYPE_POINT]: (
		state: IPropertyEditState,
		payload
	) => {
		if (state.property && state.property.PoiOfEnvironment)
			Object.keys(payload).forEach(key =>
				Vue.set(state.property.PoiOfEnvironment, key, payload[key])
			);
	},
	[propertyEnvironmentTypesStore.Set.ENVIRONMENT_ADDRESS_VALUE]: (state: IPropertyEditState, payload) => {
		Object.keys(payload).forEach(key => Vue.set(state.environmentAddress, key, payload[key]))
	},
    [propertyEnvironmentTypesStore.Set.ENVIRONMENT_ADDRESS]: (state: IPropertyEditState, payload: IPropertyEnvironmentAddressModel) => {
        state.environmentAddress = payload
    }
};

export default environmentMutations;
